import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Job } from '@contracts/interfaces/job.interface';
import { JobService } from '../../services/job.service';
import { InvoiceInterface } from '@contracts/interfaces/invoice.interface';
import { InvoicesService } from '../../services/invoices.service';
import { human } from '../../tools/human-currency';
import { PDFService } from 'src/app/services/pdf.service';
import { TemplateService } from '../../services/template.service';

export interface DialogData {
    invoice: InvoiceInterface
}

@Component({
  selector: 'app-dialog-email-receipt',
  templateUrl: 'email-receipt.dialog.html',
  styleUrls: ['./email-receipt.dialog.scss'],
  encapsulation: ViewEncapsulation.None
})
export class EmailReceiptDialogComponent {

  invoice: InvoiceInterface;
  body: any = {
    HTMI: "",
    text: ""
  };
  pdf: string = "";
  
  email: any = {}

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<EmailReceiptDialogComponent>,
    private invoiceService: InvoicesService,
    private pdfService: PDFService,
    private jobService: JobService,
    private templateService: TemplateService
    ) { }

  ngOnInit() {
    this.invoice = this.invoiceService.validate(this.data.invoice);

    this.pdfService.check(this.invoice.pdf.file, this.invoice).subscribe((result: any) => {
      this.pdf = result.hash;

      let template = "receipt.template.html"

      if (this.invoice.type == "invoice-standard") {
        this.email.subject = 'Receipt ' + this.invoice.number;
    
        this.email.sender = {
          name: "Bendigo PC Clinic",
          address: "accounts@bendigopcclinic.com.au"
        }

        this.email.attachments = [
          {
            filename: "inv-" + this.invoice.number + "-bendigo-pc-clinic.pdf",
            path: "pdfs/" + this.pdf + "/generated.pdf",
          }
        ]
      } else if (this.invoice.type == "ewaste") {
        template = "receipt-ewaste.template.html";

        this.email.sender = {
          name: "Bendigo E-Waste",
          address: "collections@bendigoewaste.com.au"
        }
        
        this.email.attachments = [
          {
            filename: "inv-" + this.invoice.number + "-bendigo-e-waste.pdf",
            path: "pdfs/" + this.pdf + "/generated.pdf",
          }
        ]

      } else if (this.invoice.type == "repair") {
        template = "receipt-repairlab.template.html";
        
        this.email.subject = 'Receipt ' + this.invoice.number;
  
        this.email.sender = {
          name: "Repair Lab",
          address: "support@repairlab.com.au"
        }
  
      this.email.attachments = [
        {
          filename: "receipt-" + this.invoice.number + "-repair-lab.pdf",
          path: "pdfs/" + this.pdf + "/generated.pdf",
        }
      ]
    } else if (this.invoice.type == "rcti-repairlab") {
      template = "receipt-repairlab.template.html";
      
      this.email.subject = 'Receipt ' + this.invoice.number;

      this.email.sender = {
        name: "Repair Lab",
        address: "support@repairlab.com.au"
      }

      this.email.attachments = [
        {
          filename: "receipt-" + this.invoice.number + "-repair-lab.pdf",
          path: "pdfs/" + this.pdf + "/generated.pdf",
        }
      ]
    } else if (this.invoice.type == "ebay-new-design") {
      template = "receipt-ebay-new-design.template.html";
      
      this.email.subject = 'Receipt ' + this.invoice.number;

      this.email.sender = {
        name: "Repair Lab",
        address: "support@repairlab.com.au"
      }

      this.email.attachments = [
        {
          filename: "receipt-" + this.invoice.number + "-ebay-new-design.pdf",
          path: "pdfs/" + this.pdf + "/generated.pdf",
        }
      ]
    }

      this.templateService.renderFile(template, this.invoice).subscribe((reply: any) => {
          this.body.HTML = reply.render;
      });
    });

  }

  close () {
    this.dialogRef.close(null);
  }

  send() {

    this.jobService.create({
      job: Job.EMAIL,
      date: {
        start: new Date()
      },
      data: {
        subject: 'Tax Invoice ' + this.invoice.number,
        sender: {
          name: "Bendigo E-Waste",
          address: "collections@bendigoewaste.com.au",
          smtp: "ewaste"
        },
        recipients: [
          {
            name: this.invoice.customer.name,
            address: this.invoice.customer.email,
          }
        ],
        body: {
          HTML: this.body.HTML,
          text: this.body.text,
        },
        attachments: [
          {
            filename: "inv-" + this.invoice.number + "-bendigo-e-waste.pdf",
            path: "pdfs/" + this.pdf + "/generated.pdf",
          }
        ]
      }
    }).subscribe(job => {

      this.dialogRef.close(job);
    });
  }
}
